<script>
	// Stores 
	import { textSite, mailComercial, linkWhatsappComercial } from '../store.js'; 

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
	import PageHeader from "../components/PageHeader.svelte";
	import Forms from "../components/Forms.svelte";
	import Vitrine from '../components/Vitrine.svelte'

	// Code
	let titlePage = 'Promoção Imperdível ';

	let vitrines = [
		{
			image: 'vitrineDiaDoSindico.jpg', 
			imageMobile: 'vitrineDiaDoSindicoM.jpg', 
			title: 'Promoção Imperdível',
			href: '#'
		}
	];	

	let fields = [
		{
			title:  'Nome do Condomínio*',
			name:   'condominio',
			required: 'required',
		},		
		{
			title:  'Endereço do Condomínio*',
			name:   'endereco',
			required: 'required',
		},
		{
			title:  'Número de Unidades*',
			name:   'unidades',
			required: 'required',
		},
		{
			title:  'Nome do Síndico*',
			name:   'nome',
			required: 'required',
		},
		{
			title:  'Telefone do Síndico*',
			name:   'telefone',
			required: 'required',
			classe: 'mask-telefone'
		},
		{
			title:  'Email do Síndico*',
			name:   'email',
			type: 'email',
			required: 'required',
		}
	];      
	
	const message = `
Nome do Condomínio: {condominio}
Endereço do Condomínio: {endereco}
Número de Unidades: {unidades}
Nome do Síndico: {nome}
Telefone do Síndico: {telefone}
Email do Síndico: {email}

{info}
	`;

	let loading = false;
	function send() {
		loading = true;
	}    

</script>

<!-- Vitrine Desabilitada 
<Vitrine vitrines={vitrines} showDots={false} vitrineHeight="460px"/>
-->

<PageHeader title={titlePage} buttons="">
	<div class="subtitle" slot="subtitle">
		<div class="container">
			<h2>Válida de 23/06/23 à 30/06/23</h2>
			<img src="/assets/images/icons/imgGestao.png" alt="" aria-disabled="true" />
			<p class="mt-20">Seu condomínio assinando contrato de administração com a Freire dentro do período da promoção, terá <b>três meses de isenção</b> da taxa de administração, e o <b>seguro incêndio do condomínio</b> no primeiro ano totalmente pago pela Freire (corretora de seguro escolhida pela Freire).</p>			
		</div>

	</div>
</PageHeader>

<div class="container clearfix text-justify mb-50">

	<div class="text-center">
		<p>Envie seu contato utilizando o formulário abaixo e tenha acesso ao download dos seguintes documentos:</p>
		<ul>
			<li><i class="fas fa-check-circle"></i> <b>Manual para Adequação dos Condomínios à Lei Geral de Proteção de Dados</b></li>
			<li><i class="fas fa-check-circle"></i> <b>Guia de Orientação do Síndico</b></li>
		</ul>

	</div>

	<div class="offset-md-3 col-md-6 pl-0 pr-0">    
		<hr class="line-separator">
		<Forms successPage="/promocaoObrigado" fields={fields} destiny={$mailComercial} subjectTitle="{titlePage}" {message} htmlbody={false} />
		<hr class="line-separator">
	</div>

	<div class="text-center mt-50 mb-50">
		<p>Em caso de dúvidas, entre em <a href="/contato" use:link>contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>

		<div class="button text-center mt-20">
			<a href="{$linkWhatsappComercial}" target="_blank" use:link replace title="Fale conosco" class="btn btn-secondary bg-whatsapp mb-20">Fale conosco <div class="arrow-animate"><i class="fab fa-whatsapp"></i></div> </a>

			<a href="/administracao-condominios" target="_blank" use:link replace title="Confira nossos diferenciais" class="btn btn-secondary mb-20">Confira nossos diferenciais <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> </a>
		</div>
	</div>

</div>